import React, { useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import FeedBackSynthesis from './FeedBackSynthesis/FeedBackSynthesis';
import Valuation from './Valuation/Valuation';
import Miscellaneous from './Miscellaneous/Miscellaneous';
import OperatingMetrics from './OperatingMetrics/OperatingMetrics';

const useStyles = makeStyles({
  navContainer: {
    width: '100%',
    position: 'sticky',
    top: '100px',
    zIndex: 9999
  },
  root: {
    width: '80%',
    margin: '1rem auto',
    borderRadius: 0,

    '& button': {
      textTransform: 'capitalize'
    },

    '& .Mui-selected': {
      fontWeight: 'bold',
      background: '#002380',
      color: '#FAFAFA',
      margin: '3px',
      borderRadius: '3px'
    }
  },
  content: {
    width: '80%',
    margin: '0 auto',
    textAlign: 'center'
  }
});

const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop - 105);

const TabNav = () => {
  const classes = useStyles();
  const [value, setValue] = useState(0);

  const feedRef = useRef(null);
  const valRef = useRef(null);
  const opRef = useRef(null);
  const miscRef = useRef(null);

  const handleChange = (e, newValue) => {
    setValue(newValue);
    switch (newValue) {
      case 0:
        scrollToRef(feedRef);
        break;
      case 1:
        scrollToRef(opRef);
        break;
      case 2:
        scrollToRef(valRef);
        break;
      case 3:
        scrollToRef(miscRef);
        break;
      default:
        break;
    }
  };

  return (
    <>
      <div className={classes.navContainer}>
        <Paper className={classes.root} elevation={0}>
          <Tabs
            centered
            indicatorColor="primary"
            onChange={handleChange}
            textColor="primary"
            value={value}>
            <Tab label="Summary of feedback" />
            <Tab label="Operating metrics" />
            <Tab label="Valuation" />
            <Tab label="Miscellaneous" />
          </Tabs>
        </Paper>
      </div>

      <div className={classes.content}>
        <div ref={feedRef}>
          <FeedBackSynthesis />
        </div>

        <div ref={opRef}>
          <OperatingMetrics />
        </div>
        <div ref={valRef}>
          <Valuation />
        </div>
        <div ref={miscRef}>
          <Miscellaneous />
        </div>
      </div>
    </>
  );
};

export default TabNav;
